import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import chroma from 'chroma-js';

const PropertyUWSchoolRating = ({ classes, selectedContainer }) => {
  if (!selectedContainer) return null;

  const { schoolScoreElementary, schoolScoreMiddle, schoolScoreHigh } = selectedContainer

  const schoolRating = [
    { school: 'Elementary School', value: schoolScoreElementary },
    { school: 'Middle School', value: schoolScoreMiddle },
    { school: 'High School', value: schoolScoreHigh }
  ];
  
  const schoolValues = schoolRating.filter(el => el.value != null).map(el => el.value); // Remove null values to calculate average
  const averageSchoolRating = schoolValues.length ? (schoolValues.reduce((p, c) => { return p + c; }) / schoolValues.length).toFixed(1) : null;

  const getColor = value => {
    if (value == null) return '#bfbfbf'; // Gray for null values
    const colorScale = chroma.scale(['red','gold','green']).domain([0, 5.0, 10.0]);
    return colorScale(value).hex();
  }

  return (
    <div className={classes.container}>
      <div>
        {schoolRating.map(school => {
          return (
            <div className={classes.newWrapper} key={school.school}>
              <Avatar style={{backgroundColor: getColor(school.value)}}>{school.value != null ? school.value : '?'}</Avatar>
              <Typography className={classes.schoolText}>
                {school.school}
              </Typography>
            </div>
          )
        })}
        <div className={classes.newWrapper}>
          <Avatar style={{backgroundColor: getColor(averageSchoolRating)}}>{averageSchoolRating != null ? averageSchoolRating : '?'}</Avatar>
          <Typography className={classes.schoolText}>
            Average
          </Typography>
        </div>
      </div>
    </div>
  )
}

const styles = theme => ({
  container: {
  },
  newWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0'
  },
  schoolText: {
    marginLeft: theme.spacing(1),
  },
});

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => ({})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyUWSchoolRating);
